export const iconFontAwesomeMaritimeFerry = (
	<i className="fa-solid fa-ferry"></i>
);
